export class AwsVpcConnectivityConfig {
    'region';
    'vpc';
    'subnetsPerAvailabilityZone';
    'securityGroups';
    'privateSubnetEnabled';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpc",
            "baseName": "vpc",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetsPerAvailabilityZone",
            "baseName": "subnetsPerAvailabilityZone",
            "type": "Array<SubnetPerAvailabilityZone>",
            "format": ""
        },
        {
            "name": "securityGroups",
            "baseName": "securityGroups",
            "type": "ResourceTypeToSecurityGroup",
            "format": ""
        },
        {
            "name": "privateSubnetEnabled",
            "baseName": "privateSubnetEnabled",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsVpcConnectivityConfig.attributeTypeMap;
    }
    constructor() {
    }
}
